import * as types from 'models/actionTypes'

export const newRenderer = () => ({
    type: types.NEW_RENDERER,
})

export const destroyRenderer = () => ({
    type: types.DESTROY_RENDERER,
})

export const rendererReady = (contextInfo) => ({
    type: types.RENDERER_READY,
    contextInfo,
})

export const firstRender = () => ({
    type: types.FIRST_RENDER,
})

export const webglContextLost = () => ({
    type: types.WEBGL_CONTEXT_LOST,
})

export const webglContextNotCreated = () => ({
    type: types.WEBGL_CONTEXT_NOT_CREATED,
})

export const webglContextRestored = () => ({
    type: types.WEBGL_CONTEXT_RESTORED,
})

export const initializationFailure = (info) => ({
    type: types.INITIALIZATION_FAILURE,
    info,
})
